<template>
  <v-app dark>
    <navbar />

    <v-content class="mx-2">
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
import Navbar from './components/Navbar'

export default {
  name: 'App',
  components: {
    Navbar
  },
  data () {
    return {
      
    }
  }
}
</script>
